module.exports = __webpack_public_path__ + "img/71b794e.jpg";